import mergeDeep from './mergeDeep';

export default function setToObject(set) {
  if (!(set instanceof Set)) {
    return {};
  }

  return [...set]
    .map((v) => {
      if (/^#\//.test(v)) {
        return v.slice(2);
      }

      if (/^\//.test(v)) {
        return v.slice(1);
      }

      return v;
    })
    .sort()
    .reduce((o, v) => {
      const segments = v.split('/');
      const nestedObj = segments.reduceRight((_v, _k) => ({ [_k]: _v }), true);

      return mergeDeep(o, nestedObj);
    }, {});
}
